import React from 'react'
import cx from 'classnames'
import { useMemo } from 'sb-hooks'
import { getUserPublicName } from 'common/helpers'

import Link from 'components/ui/Link/Link'
import { Avatar } from 'components/_new/ui'

import s from './UserInfo.scss'


export type UserInfoProps = {
  username?: string
  firstName?: string
  lastName?: string
  gender: Gender
  url: string
  avatar?: string
  avatarClassName?: string
  userNameClassName?: string
  withMicrodata?: boolean
}


const UserInfo: React.FunctionComponent<UserInfoProps> = (props) => {
  const {
    firstName, lastName, username: legacyUsername, gender, url, avatar,
    avatarClassName, userNameClassName, withMicrodata = false,
  } = props

  const username = useMemo(() => {
    // TODO remove when productPageGql will be removed and enabled by default - added on 2020-12-30 by maddoger
    if (legacyUsername) {
      return legacyUsername
    }

    return getUserPublicName({ firstName, lastName })
  }, [ firstName, lastName, legacyUsername ])

  const microdata = useMemo(() => {
    if (withMicrodata) {
      return {
        itemScope: true,
        itemProp: 'author',
        itemType: 'http://schema.org/Person',
      }
    }

    return null
  }, [ withMicrodata ])

  return (
    <Link
      className={s.userInfo}
      toOLD={url}
      blackColor
      {...microdata}
    >
      <Avatar
        className={cx(s.avatar, avatarClassName)}
        gender={gender}
        src={avatar}
        circle
      />
      <div
        className={cx(s.username, userNameClassName)}
        {...withMicrodata && { itemProp: 'name' }}
      >
        {username}
      </div>
    </Link>
  )
}


export default UserInfo
